module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-5.e64e2b3c.png";